import {
  FETCH_REPORT_BEGIN,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_FAILURE,
  UPDATE_REPORT_BEGIN,
  UPDATE_REPORT_SUCCESS,
  UPDATE_REPORT_FAILURE,
  CREATE_COMMENT_BEGIN,
  CREATE_COMMENT_SUCCESS,
  CREATE_COMMENT_FAILURE,
  DELETE_COMMENT_BEGIN,
  DELETE_COMMENT_SUCCESS,
  FETCH_COMMENT_FAILURE,
  FETCH_COMMENT_BEGIN,
  FETCH_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  UPDATE_COMMENT_BEGIN,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_FAILURE,
  SCROLL_COMPLETE,
  DELETE_COMMENT_IMAGE_BEGIN,
  DELETE_COMMENT_IMAGE_SUCCESS,
  DELETE_COMMENT_IMAGE_FAILURE,
  ADD_COMMENT_IMAGE_BEGIN,
  ADD_COMMENT_IMAGE_SUCCESS,
  ADD_COMMENT_IMAGE_FAILURE,
  DOWNLOAD_REPORT_BEGIN,
  DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_FAILURE,
  REORDER_COMMENTS_BEGIN,
  REORDER_COMMENTS_SUCCESS,
  REORDER_COMMENTS_FAILURE,
  START_EDIT,
  END_EDIT,
} from "../actions/actionTypes";

const initialState = {
  loading: false,
  didInvalidate: true,
  shouldScrollToBottom: false,
  didAddComment: false,
  mode: "view",
};

const report = (state = initialState, action) => {
  switch (action.type) {
    case START_EDIT:
      return {
        ...state,
        mode: "edit",
      };
    case END_EDIT:
      return {
        ...state,
        mode: "view",
      };
    case FETCH_REPORT_BEGIN:
      return {
        ...state,
        loading: true,
        didInvalidate: false,
        result: null,
      };
    case FETCH_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        didInvalidate: false,
        result: action.payload.result,
        shouldScrollToBottom: state.didAddComment,
        didAddComment: false,
        mode: "view",
      };
    case FETCH_REPORT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case FETCH_COMMENT_BEGIN:
      return {
        ...state,
        loading: true,
        didInvalidate: false,
        result: null,
      };
    case FETCH_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        didInvalidate: false,
      };
    case FETCH_COMMENT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case UPDATE_REPORT_BEGIN:
      return {
        ...state,
        loading: true,
        didInvalidate: false,
        result: null,
      };
    case UPDATE_REPORT_SUCCESS:
      return {
        ...state,
        didInvalidate: true,
        result: action.payload.result,
        mode: "view",
      };
    case UPDATE_REPORT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case CREATE_COMMENT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CREATE_COMMENT_SUCCESS:
      return {
        ...state,
        // TODO: either
        //        1. just fetch the report again, which its doing now
        //        2. just push the new comment into reports.comment
        //        2. move comments into their own part of this state, and push there
        didInvalidate: true,
        loading: false,
        didAddComment: true,
      };
    case CREATE_COMMENT_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case DELETE_COMMENT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        didInvalidate: true,
        loading: false,
      };
    case DELETE_COMMENT_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_COMMENT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_COMMENT_SUCCESS:
      return {
        ...state,
        didInvalidate: true,
        loading: false,
      };
    case UPDATE_COMMENT_FAILURE:
      return {
        ...state,
        didInvalidate: true,
        loading: false,
      };
    case SCROLL_COMPLETE:
      return {
        ...state,
        shouldScrollToBottom: false,
      };
    case DELETE_COMMENT_IMAGE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_COMMENT_IMAGE_SUCCESS:
      return { ...state, loading: false, didInvalidate: true };
    case DELETE_COMMENT_IMAGE_FAILURE:
      return { ...state, loading: false };
    case ADD_COMMENT_IMAGE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_COMMENT_IMAGE_SUCCESS:
      return { ...state, loading: false, didInvalidate: true };
    case ADD_COMMENT_IMAGE_FAILURE:
      return { ...state, loading: false };
    case REORDER_COMMENTS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case REORDER_COMMENTS_SUCCESS:
      return { ...state, loading: false, didInvalidate: true };
    case REORDER_COMMENTS_FAILURE:
      return { ...state, loading: false };
    case DOWNLOAD_REPORT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_REPORT_SUCCESS:
    case DOWNLOAD_REPORT_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default report;
